export enum UnitType {
  TECHNICAL = 'TECHNICAL',
  COMMERCIAL = 'COMMERCIAL'
}
